<template>
  <div></div>
</template>

<script>
export default {
  name: 'EcSpinner'
}
</script>

<style scoped>
/* No styles needed as component is empty */
</style>
